import { RequestBuilder } from "../requestBuilder";
import { SettingInputSchema, SettingKeyInputSchema, SettingsResponseSchema } from "./settingsClient.types";

// GET /settings - Every setting the current user has a row for (user-scoped)
export const SettingsRequestConfig = new RequestBuilder({
  path: () => "/settings",
  responseSchema: SettingsResponseSchema,
});

// POST /settings - Create a setting. Fails when the key already has a row.
export const CreateSettingRequestConfig = new RequestBuilder({
  path: () => "/settings",
  bodySchema: SettingInputSchema,
}).withMethod("POST");

// PUT /settings - Update an existing setting. 404s when the key has no row.
export const UpdateSettingRequestConfig = new RequestBuilder({
  path: () => "/settings",
  bodySchema: SettingInputSchema,
}).withMethod("PUT");

// DELETE /settings - Remove a setting so its key falls back to the system
// default. Idempotent: deleting a key with no row still succeeds.
export const DeleteSettingRequestConfig = new RequestBuilder({
  path: () => "/settings",
  bodySchema: SettingKeyInputSchema,
}).withMethod("DELETE");
